export class ResponseError {
}
